import { ThemeOptions } from '@mui/material/styles';
import { green, red, yellow, purple } from '@mui/material/colors';
export const CXoneBreezeThemeOptions = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 360,
      md: 575,
      lg: 768,
      xl: 1015,
    },
  },
  palette: {
    // mode: 'dark',
    primary: {
      main: '#007CBE',
      dark: '#1c639c',
    },
    secondary: {
      main: '#526b7a',
    },
    success: {
      main: '#39c44a',
      dark: '#23762d',
    },
    error: {
      main: '#e62e43',
    },
    warning: {
      main: '#fde000',
      dark: '#EFA716',
    },
    info: {
      light: '#2498d5',
      main: '#2179c1',
    },
    accent: {
      main: '#ffb000',
      dark: '#C78800',
    },
    text: {
      main: '#808080',
      light: '#8c95a5',
      dark: '#001633',
      contrastText: '#333333',
      primary: '#191c21',
      secondary: '#616c75',
      active: '#306484',
      information: '#006398', // TODO- will be removed once the theme palette is complete
      header: '#767676',
      noteLabel: '#007AB8',
      highlight: '#AF008D',
      messageText: '#AFAFAF',
      black: '#000000',
      grey: '#CCCECF',
      white: '#FFFFFF',
      searchTitle: '#004466',
      filter: '#3F5C69',
      yellowWarning: '#D78F05',
      clearText: '#003D7A',
      noResult: '#929292',
      red: '#C2041A',
      green: '#00B168',
      lightGrey: '#C3C5C9',
      charcolGrey: '#4a4a4a',
      // TODO- will be removed once the theme palette is complete
    },
    background: {
      paper: '#fff',
      default: '#f2f2f2',
      level1: '#f8fafb',
      LogoColor: '#eaf0f6',
      main: '#dedede',
      dark: '#066da3',
      light: '#f8fafb',
      hover: '#ecf5fa',
      hoverDark: '#343A41',
      toolTipBg: '#444d57',
      callControlHeader: '#f5f8fa',
      sparkleBlue: '#067EFF',
      toastBackground: '#fdeeef',
      noteInput: '#ECF3F8',
      noteBackground: '#FCE69D',
      outboundOptionBg: '#e2edff',
      scrollTrack: '#f4f7f9',
      scrollThumb: '#c9d0d6',
      scrollThumbHover: '#5555',
      socialReaction: '#005C99',
      transparent: 'transparent',
      selectedQueue: '#d9ebf5',
      digitalTag: '#b0cddb',
      header: '#e3e9ee40',
      lightBlue: '#6AB2FF',
      darkGrey: '#79797A',
      lavenderBlush: '#FDF0F1',
      lightYellow: '#FFB00014',
      darkYellow: '#FBC231',
      zoomIconsBackground: '#C3C5C7',
      checkboxHover: '#DBE6F0',
      darkBlue: '#107DBC',
      callControls: '#E4263C',
      copilotAddButton: '#107DBC',
      copilotGenerateButton: '#AFC1CE',
      copilotCardBackground: '#F8F8F9',
      audioPlayerColor:'#003D7A',
      slateGrey: '#E6E6E6',
    },
    disposition: {
      required: purple[600],
      optional: red[700],
    },
    agentState: {
      available: green[400],
      unavailable: red[700],
      working: yellow[800],
    },
    boxshadow: {
      main: '#00000029',
      light: '#dde4e9',
      hover: '#ffffff29',
    },
    border: {
      main: '#dae2e8',
      dark: '#F6F6F6',
      light: '#DAE1E7',
      yellow: '#FBC231',
    },
    divider: '#e3e9ee',
  },
  typography: {
    button: {
      textTransform: 'none',
    },
    allVariants: {
      fontFamily: `'Open Sans', sans-serif`,
    },
    fontFamily: `'Open Sans', sans-serif`,
    h6: { fontSize: '0.75em' /* 12px */ },
    h5: { fontSize: '0.8750em' /* 14px */ },
    h4: { fontSize: '1em' /* 16px */ },
    h3: { fontSize: '1.17em' /* 18.72px */ },
    h2: { fontSize: '1.5em' /* 24px */ },
    h1: { fontSize: '2em' /* 32px */ },
  },
  override: {
    Muibutton: {
      root: {
        textTransform: 'capitalize',
      },
    },
  },
  props: {
    MuiButton: {
      disableRipple: true,
      color: 'primary',
    },
    MuiCheckbox: {
      disableRipple: true,
      color: 'primary',
    },
  },
  components: {
    MuiUseMediaQuery: {
      defaultProps: {
        noSsr: true,
      },
    },
  },
} as ThemeOptions;
